import { ApprovalInboxFeaturePage } from "../ui";

/** 待我审批业务路由。 */
export function ApprovalInboxPage() {
  return <ApprovalInboxFeaturePage />;
}
